export default __webpack_public_path__ + "static/media/logo-navigation@2x.2e76cd4c.png";